import { ClientRegisterTemplate } from "../../Templates/ClientRegisterTemplate";

export const ClientRegister = () => {
  return <ClientRegisterTemplate />;
};
